import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { IUploadedFileTypesResponse } from '../models/uploaded-file-types.model';

export const loadUploadedFileTypes = createAction('[UploadedFileTypes] Load Uploaded File Types');

export const loadUploadedFileTypesSuccess = createAction(
  '[UploadedFileTypes] Load Uploaded File Types Success',
  props<{ response: IUploadedFileTypesResponse[] }>()
);

export const loadUploadedFileTypesFailure = createAction(
  '[UploadedFileTypes] Load Uploaded File Types Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
